// import { articleImageCarousel } from '../../components/swiper-slider/_swiper-controller';

// if (document.querySelector('.start-from-center-carousell')) {
//   articleImageCarousel();
// }
